import { z } from 'zod';

export const ConfiguracaoEmpresaInput = z.object({
  nomeEmpresa: z.string().trim().min(1).max(80),
});

export type ConfiguracaoEmpresaOutput = {
  nomeEmpresa: string;
};

export type ConfiguracaoEmpresaInputType = z.infer<typeof ConfiguracaoEmpresaInput>;
export type ConfiguracaoEmpresaOutputType = ConfiguracaoEmpresaOutput;
